import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {Mental} from "../Mental";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {FeaturePresentationHelper} from "../utils/FeaturePresentationHelper";

export class MentalScatter2Explosion extends PIXI.Container implements StageLayer {

    public static playScatter2ExplosionAnimation(reelId: number, symId: number, actualIdx: number, xWaysOccurred: boolean, yPos: number, explosionHeight: number): TimelineLite {
        const symWidth: number = 144,
            symHeight: number = 198,
            symSegments: number = Mental.model.gameData.currentSymbolSize[reelId][symId],
            symSegmentHeight: number = (symHeight / symSegments),
            reelAreaTop: number = 90,
            reelTop: number = (reelId % 2 === 1) ? (reelAreaTop + (symHeight / 2)) : (reelAreaTop),
            extraYAsPerActualIdx: number = (symSegmentHeight !== symHeight ? actualIdx * symSegmentHeight : 0),
            explosion: TimelineSprite = new TimelineSprite(Mental.assetLoader.getTextures("s2Explosion"));

        NolimitApplication.getLayerByName(Mental.LAYERS.SPEED_STER)?.addChild(explosion);
        explosion.anchor.set(0.5);

        // if explosion is running on xWaysBg/enhancer item.
        if (explosionHeight) {
            explosion.scale.y = (explosionHeight / symHeight) * 2;
        }
        // if xWays has occurred on any reel
        else if (xWaysOccurred) {
            const ht: number = FeaturePresentationHelper._symbolHeightOnReel[reelId];
            explosion.scale.y = (ht / symHeight) * 2;
        } else {
            explosion.scale.y = (1 / symSegments) * 2;
        }

        // if someone passed the y position for explosion.
        if (yPos) {
            explosion.y = yPos;
        }
        // if xWays has occurred on any reel
        else if (xWaysOccurred) {
            const ht: number = FeaturePresentationHelper._symbolHeightOnReel[reelId];
            explosion.y = reelTop + (ht * actualIdx) + (ht / 2);
        } else {
            explosion.y = reelTop + ((symHeight * symId) + (symSegmentHeight / 2)) + extraYAsPerActualIdx;
        }
        explosion.x = (symWidth * reelId) + (symWidth / 2);
        explosion.scale.x = 2;

        return explosion.getAnimationAutoShowHide(true, true, undefined, undefined, () => {
            NolimitApplication.getLayerByName(Mental.LAYERS.SPEED_STER)?.removeChild(explosion);
        }).timeScale(explosion.totalDuration / Mental.timeSegment);
    }

    // #230
    public static clearAll(): void {
        NolimitApplication.getLayerByName(Mental.LAYERS.SPEED_STER)?.removeChildren();
    }
}